import { Icon, IconButtonInnerChild } from "@evergis/ui";
import styled from "styled-components";
import { AddBlock } from "../styled";

import infoEmpty from "./assets/info_empty.svg";

export const InfoBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  &:hover {
    ${AddBlock} {
      visibility: visible;
    }
  }
`;

export const EmptyBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 4rem auto;
  width: 400px;
  align-items: center;
`;

export const EmptyBlockIcon = styled.div`
  width: 2rem;
  height: 2rem;
  background: url(${infoEmpty}) no-repeat;
  margin-bottom: 1.5rem;
`;

export const EmptyBlockTitle = styled.div`
  font-size: 20px;
  margin-bottom: 0.5rem;
`;

export const EmptyBlockDescription = styled.div`
  font-size: 12px;
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.palette.textSecondary};
`;

export const EmptyBlockActions = styled.div`
  display: flex;
  gap: 0 1.5rem;

  ${Icon}:after {
    color: ${({ theme }) => theme.palette.icon};
  }

  ${IconButtonInnerChild} {
    color: ${({ theme }) => theme.palette.textSecondary};
    font-size: 12px;
  }
`;
